const allShoeApi = [{
    id: 0,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/7f8ee038-906a-47a9-8296-be17b4bdda94/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/a229b012-c62d-4f89-9ed2-3fca4bbe274a/air-jordan-1-retro-high-og-shoes-G8hcQx.png"
    },
    gallery: {
        One: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/b3cb2095-b729-404b-8cdc-3383771d0036/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        two: "https://static.nike.com/a/videos/q_90,vc_vp9/e4843e32-a354-4cc2-b5ad-71c01a71ceff/video.webm",
        three: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/238b740d-ce6e-4b9b-8c67-b595fa4973ae/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        four: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/095f7378-7f3e-4940-aa95-4bfea80259c0/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        five: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/77ee419d-5cdc-4572-94f2-0974c4ad1b4a/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        six: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/bfc1c6ce-ee36-4a7c-b1d7-483216ed86e6/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        seven: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/110bb94e-dd4f-4a77-9224-259878f00c06/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        eight: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/8bde5b7a-b7aa-4610-b3ea-1a138359b376/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        nine: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/65cc41ab-7a42-423b-a531-04bf36fb2380/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        ten: "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/13ac30f3-c977-4b8c-883d-8cad04c53196/air-jordan-1-retro-high-og-shoes-G8hcQx.png",

    },
    offer: "Promo Exclution",
    shoeName: "Air Jordan 1 Retro High OG",
    type: "Shoes",
    colors: 2,
    price: "₹ 15 995"
}, {
    id: 1,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/dc9efa13-9572-490e-afa9-4c5b8e25187a/air-jordan-1-mid-se-shoes-pZbfP8.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/616a8a2f-193d-437c-b336-b4df8eacf0d3/air-jordan-1-mid-se-shoes-pZbfP8.png"
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/a5b25746-8542-44ef-afcc-39a77628fd9a/air-jordan-1-mid-se-shoes-pZbfP8.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/3774050b-8ff2-4c1d-83fc-e9532b623d3a/air-jordan-1-mid-se-shoes-pZbfP8.png",
        four:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/99ff7363-6358-4a3e-9c18-4157577aafac/air-jordan-1-mid-se-shoes-pZbfP8.png",
        five:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/0c1ce2f8-7067-4365-b210-3367d9d139c5/air-jordan-1-mid-se-shoes-pZbfP8.png",
        six:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/49c91ef0-5ae3-45a9-a388-75c6a122751b/air-jordan-1-mid-se-shoes-pZbfP8.png",
        seven:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/3ac107ab-ab57-4676-9c79-5caeae016934/air-jordan-1-mid-se-shoes-pZbfP8.png",
        eight:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/870f819b-f67e-4f3b-a5a3-d7d41f910e2d/air-jordan-1-mid-se-shoes-pZbfP8.png",
        nine:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/33d8ac8d-1e49-4e97-b750-5270c81e6133/air-jordan-1-mid-se-shoes-pZbfP8.png",

},
    offer: "Promo Exclution",
    shoeName: "Air Jordan 1 Mid SE",
    type: "Men's Shoes",
    colors: 2,
    price: "₹ 11 895"
}, {
    id: 2,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/2309c6be-a253-495f-915c-0c5041c6751f/terminator-high-shoes-JGFfv4.png",
        
    }, 
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/01bd1598-c5ec-4e43-978f-42370cbbedd3/terminator-high-shoes-JGFfv4.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c80ba450-91ea-4ff0-9293-cc99adf40107/terminator-high-shoes-JGFfv4.png",
        four:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/712ed631-f397-42da-9d65-e21793a50bfb/terminator-high-shoes-JGFfv4.png",
        five:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/031fd494-007b-46a5-90aa-dd16ea917843/terminator-high-shoes-JGFfv4.png",
        six:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/82bd6d7c-9299-4fc2-bc08-68ef4829bd4d/terminator-high-shoes-JGFfv4.png",
        seven:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/541ef991-ba96-4ab8-9120-577493daf4c1/terminator-high-shoes-JGFfv4.png",
        eight:"",
        nine:"",

},
    offer: "Just In",
    shoeName: "Nike Terminator High",
    type: "Men's Shoes",
    colors: 1,
    price: "₹ 12 795"
}, {
    id: 3,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/589e8719-84e3-43ef-84cf-c22cb5c1513a/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        
    }, 
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/48218cfd-b69e-4f63-9f24-7dc0ce1b6f60/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/118ae027-7b03-417e-9193-ddac64663850/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        four:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/da8e38cd-bf3e-4cd1-b4e5-3bb015835776/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        five:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/0527d11a-a1bb-452c-9261-0450163a8756/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        six:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/f47c39de-efb5-4ac0-9cdd-dd368c8f93f4/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        seven:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/a8507eeb-dab6-41fd-b24d-e4954e4d2824/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        eight:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/fff8db3d-2071-42f2-b3f5-d6ff0ac5f379/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        nine:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/afb82187-9db8-45b3-ba15-fe679144d0b2/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",
        ten:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/1971e853-c03e-4f5f-8386-5b69e77dbd9d/air-zoom-alphafly-next-2-road-racing-shoes-MRSlSl.png",

},
    offer: "Promo Exclution",
    shoeName: "Nike Air Zoom Alphafly NEXT% 2",
    type: "Men's Road Racing Shoes",
    colors: 1,
    price: "₹ 22 795"
}, {
    id: 4,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/0fe8e64a-6c6e-4779-9758-c440a25c09f9/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/e68e5312-d465-4641-bfa6-53da7b7e78b9/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        imgThree: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/93536e83-3116-4e49-81b5-fa66060473d8/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        imgFour: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/96d49c33-dea5-4b28-95f6-fceeb8e273f0/vaporfly-next-2-road-racing-shoes-D4ntS0.png"
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/639d80d9-32bc-4c15-ab9c-0c4d1984c716/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/d028d335-d046-46f1-96a7-9605f3601028/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/5b1f9451-0e53-4b86-aa7d-e9d4cf2d47e3/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        four:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/58dddf97-aec2-47bc-ade3-4687cf5bd712/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        five:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/a7aac8f9-98fb-43da-9ea5-a9f9694d6895/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        six:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/87704f78-a296-45dc-b911-874382a57c28/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        seven:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/e3e71baf-8962-45f8-b42c-c50e47fac2ac/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        eight:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/6971a73c-ff26-497b-b929-07157eda0fe4/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        nine:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/5f127d82-d9eb-4de7-89bd-bcc9bbc1e955/vaporfly-next-2-road-racing-shoes-D4ntS0.png",
        ten:"",

},
    shoeName: "Nike Vaporfly NEXT% 2",
    type: "Men's Road Racing Shoes",
    colors: 4,
    price: "₹ 18 707"
}, {
    id: 5,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/3df7160f-4d72-4254-bb2e-39626055f7f6/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/7f6e3bd8-568b-46e5-bf45-bb4f8fd07e4a/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        imgThree: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/0bb87192-51a9-4a31-9e62-cd616f46a79c/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        imgFour: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/3df7160f-4d72-4254-bb2e-39626055f7f6/air-zoom-tempo-next-road-running-shoes-chNfdw.png"
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/b69d1007-7a39-46bd-8236-42a002dc8326/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/b2ff924c-2548-4263-94f2-e3e715f2a5e9/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/df7190e7-44f8-44cb-b2fc-6aa5e9a808c0/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        four:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/b8cde4ef-1325-4e08-a01c-bc5cfd8fae3b/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        five:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/97162e99-d78d-4efb-89dd-0dd6ac215fdc/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        six:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/9cc89672-5800-4b8e-be24-225ea63b4e42/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        seven:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/7c96afb1-561f-4a5d-abc2-a88d5db99787/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        eight:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/b0e21d5d-9def-4b8d-8d41-2bdae49704b8/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        nine:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/48274cce-f7ff-4d9c-8526-fa1493937239/air-zoom-tempo-next-road-running-shoes-chNfdw.png",
        ten:"",

}, 
    offer: "Promo Exclution",
    shoeName: "Nike Air Zoom Tempo NEXT%",
    type: "Men's Road Racing Shoes",
    colors: 4,
    price: "₹ 16 717"
}, {
    id: 6,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/0f3036cb-8b5b-4adb-998f-9c732d5818cb/dunk-low-shoes-w37m3B.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/1ff0d87f-18c8-4f08-99cb-12fa59e289a8/dunk-low-shoes-w37m3B.png"
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/89f80715-9b70-4b97-81d3-bc3859bcc894/dunk-low-shoes-r8QXCd.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/8c4af58d-d5ee-4297-a5a6-3458b42c678b/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/26d71a26-0aa6-4c92-a1e0-537c574d3c2a/dunk-low-shoes-r8QXCd.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/0b22a361-5065-4845-b3b9-d872134623c0/dunk-low-shoes-r8QXCd.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/6bdbf3a8-b0bb-4baa-96d0-ee61407c3fc5/dunk-low-shoes-r8QXCd.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/41652b41-f610-4a2e-84c9-40474c28ed1e/dunk-low-shoes-r8QXCd.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/2c9aec1e-4b4f-4197-94a1-905329d5075e/dunk-low-shoes-r8QXCd.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/21503fb1-fe0c-489d-a833-f0747d1ffaeb/dunk-low-shoes-r8QXCd.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/bffbcc0e-7c4c-4800-9fb9-e144e691d0e0/dunk-low-shoes-r8QXCd.png",
        ten:"",

},
    offer: "Promo Exclution",
    shoeName: "Nike Dunk Low",
    type: "Men's Shoes",
    colors: 2,
    price: "₹ 9 695"
}, {
    id: 7,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/44c7d116-ae35-4a39-b1eb-47d6a699c7c3/dunk-low-retro-shoes-9L8Z5s.png",
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/ac228f73-6167-432b-b4bb-2a7c6a63bd57/dunk-low-retro-shoes-9L8Z5s.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/f979bc82-991f-4e50-abb6-5f334e067223/dunk-low-retro-shoes-9L8Z5s.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/137d5982-5931-4e63-8342-037670637a04/dunk-low-retro-shoes-9L8Z5s.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/e90e4aca-35db-425c-8873-178aff5db1de/dunk-low-retro-shoes-9L8Z5s.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/e3b66b27-5572-496e-a257-7d263dd5570d/dunk-low-retro-shoes-9L8Z5s.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/3b7fc193-4674-4a2a-9475-de5392690b23/dunk-low-retro-shoes-9L8Z5s.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/b03bf24c-5e79-4de4-aca6-29b98f9590c5/dunk-low-retro-shoes-9L8Z5s.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/3d81c81a-ddeb-4e7e-8bb4-2267720f8620/dunk-low-retro-shoes-9L8Z5s.png",
        ten:"",

},
    offer: "Promo Exclution",
    shoeName: "Nike Dunk Low Retro Premium",
    type: "Men's Shoes",
    colors: 1,
    price: "₹ 9 695"
}, {
    id: 8,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/0e563f3b-6e63-4165-98ff-e07551b1cd21/dunk-low-retro-shoes-KZmSsj.png",
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/e1f8c05c-6237-4149-b9c3-b1c40e131cc8/dunk-low-retro-shoes-KZmSsj.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/d37914ae-bbba-4ed4-8965-610f91a7aa10/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/a77cfe11-68e3-4045-a3e5-2b2beeaec156/dunk-low-retro-shoes-KZmSsj.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/d411b918-79d5-4ff3-ab80-10e2a923fccd/dunk-low-retro-shoes-KZmSsj.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/c055aa15-d28f-49ed-83fa-717b23c93127/dunk-low-retro-shoes-KZmSsj.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/a723cb2d-a013-4c44-90df-eac14636371b/dunk-low-retro-shoes-KZmSsj.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/207648cd-f7f0-43ca-a07e-58b4953d0bcb/dunk-low-retro-shoes-KZmSsj.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/3a1bdc56-c584-4b72-99d9-12e1779c58df/dunk-low-retro-shoes-KZmSsj.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/267a583d-f668-46c5-a606-6c860d48f4a9/dunk-low-retro-shoes-KZmSsj.png",
        ten:"",

},
    offer: "Promo Exclution",
    shoeName: "Nike Dunk Low Retro Premium",
    type: "Men's Shoes",
    colors: 1,
    price: "₹ 9 695"
}, {
    id: 9,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/762f36d7-90d1-448e-b333-2459d36b6ea2/air-jordan-11-retro-low-ie-shoes-30kr7w.png",
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_LOADING_v1/f_auto,q_auto:eco/7ae09ea8-c07b-4d98-92f6-67b5f10ee9b0/air-jordan-11-retro-low-ie-shoes-30kr7w.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/be2effdf-d76d-49cc-a12c-8bd1406c642b/air-jordan-11-retro-low-ie-shoes-30kr7w.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/62485374-53c7-487b-802f-55014e68f46b/air-jordan-11-retro-low-ie-shoes-30kr7w.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/bf5a15d8-6b7c-411b-9c9a-89e858a608b2/air-jordan-11-retro-low-ie-shoes-30kr7w.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/a173489c-a906-4e6a-b185-c30a24cd2f57/air-jordan-11-retro-low-ie-shoes-30kr7w.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/ec07d3af-9af3-4c6b-8fd9-4f1fbcf9e803/air-jordan-11-retro-low-ie-shoes-30kr7w.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/ffc1621c-6b04-4a9c-ba70-715a6f52706c/air-jordan-11-retro-low-ie-shoes-30kr7w.png",
        nine:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/65cc41ab-7a42-423b-a531-04bf36fb2380/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        ten:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/13ac30f3-c977-4b8c-883d-8cad04c53196/air-jordan-1-retro-high-og-shoes-G8hcQx.png",

},
    offer: "Promo Exclution",
    shoeName: "Air Jordan 11 Retro Low IE",
    type: "Men's Shoes",
    colors: 1,
    price: "₹ 16 995"
}, {
    id: 10,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/817562f6-7781-4f26-b14c-8a82fc8818fb/air-max-90-gtx-shoes-h08kfP.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/e0244d8e-e42e-43d8-9326-7227720680d6/air-max-90-gtx-shoes-h08kfP.png"
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/b3cb2095-b729-404b-8cdc-3383771d0036/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/e4843e32-a354-4cc2-b5ad-71c01a71ceff/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/238b740d-ce6e-4b9b-8c67-b595fa4973ae/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        four:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/095f7378-7f3e-4940-aa95-4bfea80259c0/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        five:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/77ee419d-5cdc-4572-94f2-0974c4ad1b4a/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        six:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/bfc1c6ce-ee36-4a7c-b1d7-483216ed86e6/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        seven:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/110bb94e-dd4f-4a77-9224-259878f00c06/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        eight:"https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/8bde5b7a-b7aa-4610-b3ea-1a138359b376/air-jordan-1-retro-high-og-shoes-G8hcQx.png",
        nine:"",
        ten:"",

},
    shoeName: "Nike Air Max 90 GTX",
    type: "Men's Shoes",
    colors: 2,
    price: "₹ 13 995"
}, {
    id: 11,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/aa13b417-d005-41a5-a0b5-9100b1556121/air-max-scorpion-flyknit-shoes-4dWrx1.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/1cfee931-2ae7-4f43-8b9f-e333ba7d2fc5/air-max-scorpion-flyknit-shoes-4dWrx1.png"
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/efc9de26-5f37-4a37-a49b-3bf8639076d0/air-max-scorpion-flyknit-shoes-DP54Sv.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/3c93e6be-3b5f-4336-af41-da346f127403/air-max-scorpion-flyknit-shoes-DP54Sv.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/7a6a8ec9-e4ff-4835-9d19-40cc3711dfaa/air-max-scorpion-flyknit-shoes-DP54Sv.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/d788cb32-f0e4-4426-acdf-f25b4ad3d574/air-max-scorpion-flyknit-shoes-DP54Sv.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/a6b1dca5-e40e-485e-91fa-e01d91173335/air-max-scorpion-flyknit-shoes-DP54Sv.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/0cdf206e-6d5b-469c-9f79-455611ebd2d2/air-max-scorpion-flyknit-shoes-DP54Sv.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/8fa7b8a8-bd59-47f4-aa2d-853bb4f419be/air-max-scorpion-flyknit-shoes-DP54Sv.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/9f9d9acc-0e45-4186-b865-7b8ed4009a03/air-max-scorpion-flyknit-shoes-DP54Sv.png",
        ten:"",

}, 
    offer: "Sustainable Materials",
    shoeName: "Nike Air Max Scorpion Flyknit",
    type: "Men's Shoes",
    colors: 2,
    price: "₹ 22 995"
}, {
    id: 12,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/0d6e3a59-b734-4701-862d-f1d881c7ecd5/pegasus-39-road-running-shoes-kmZSD6.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/b39ed3f1-f3c8-47f9-8831-0782665a6715/pegasus-39-road-running-shoes-kmZSD6.png",
        imgThree: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/5951ebe8-8cac-415c-b1b4-714b5313af35/pegasus-39-road-running-shoes-kmZSD6.png",
        imgFour: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/7a563c5a-6048-4804-97a4-1cc4de6f6097/pegasus-39-road-running-shoes-kmZSD6.png",
    },
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/5c78ac92-88f6-4a97-ad25-e356d20fea2e/air-jordan-1-retro-high-og-shoe-PLe8kL.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/wmoos0kbczqz33y2gzfz/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/8c0de6bc-d23d-4a65-8d10-6ccaba5b07ab/air-jordan-1-retro-high-og-shoe-PLe8kL.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/48c16a7e-519c-46fb-bb79-ac07913a92e2/air-jordan-1-retro-high-og-shoe-PLe8kL.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/1e2e40e8-e7c8-4eb4-8e93-1006e61fce57/air-jordan-1-retro-high-og-shoe-PLe8kL.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/91562f6d-f64f-4cf7-a964-00e58a26d134/air-jordan-1-retro-high-og-shoe-PLe8kL.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/52ba897e-511b-420c-bb87-ba2b001f025a/air-jordan-1-retro-high-og-shoe-PLe8kL.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/4c025c55-deb4-45cb-a9ed-3b148d5e879c/air-jordan-1-retro-high-og-shoe-PLe8kL.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/1c560cf1-6f2d-43b2-b233-861121a64177/air-jordan-1-retro-high-og-shoe-PLe8kL.png",
        ten:"",

},
     offer: "Promo Exclution",
    shoeName: "Air Jordan 1 Retro High OG",
    type: "Shoes",
    colors: 4,
    price: "₹ 15 995"
}, {
    id: 13,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/8dd471ed-efa0-43b8-a388-73ae7b316cc2/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/8f492ad4-ae58-4393-9398-d8c19001dd54/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        imgThree: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/7d757c87-87a5-4e15-a3c4-29587b526fb9/air-jordan-12-low-golf-shoes-GpK0Fl.png"
    }, 
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/4b3da135-aef5-440a-9a9b-f6669a78428f/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/f793c62d-48eb-41d6-afa4-4fdab8e4d85d/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/a3dd36c3-639a-4f4b-bc87-6c857a3a81cc/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/7a7fbf49-42cb-4cb7-92c2-2e43c3019a13/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/e8373e63-2923-416e-a8c5-902e84a0240a/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/b057eb77-1bc4-46a7-82c7-6aa3eddb01e2/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/5375e689-6e23-4d45-98ec-4ef7751b3ba4/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/3b945d7a-cb38-4f85-adfd-a67d450a16fc/air-jordan-12-low-golf-shoes-GpK0Fl.png",
        ten:"",

},
    offer: "Just In",
    shoeName: "Air Jordan 12 Low",
    type: "Golf Shoes",
    colors: 3,
    price: "₹ 18 707"
}, {
    id: 14,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/dc9efa13-9572-490e-afa9-4c5b8e25187a/air-jordan-1-mid-se-shoes-pZbfP8.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/616a8a2f-193d-437c-b336-b4df8eacf0d3/air-jordan-1-mid-se-shoes-pZbfP8.png"
    }, 
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/4173e966-5dd2-4ea2-adb2-115129a9d1c0/air-force-1-07-lv8-shoes-HZj8RK.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/66695227-bd2e-4d98-b812-7f3304e1c457/air-force-1-07-lv8-shoes-HZj8RK.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/b85cb5b8-1300-4d59-8860-2266118114dc/air-force-1-07-lv8-shoes-HZj8RK.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/886e1c89-1118-43a6-b961-5c34285c9a45/air-force-1-07-lv8-shoes-HZj8RK.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/060cf081-168f-4e7a-add2-7580c7255ea9/air-force-1-07-lv8-shoes-HZj8RK.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/ac790962-df2a-45c6-84c4-b2a320933b8f/air-force-1-07-lv8-shoes-HZj8RK.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/fac366b1-68ab-4a10-b21a-3ebf6b81262e/air-force-1-07-lv8-shoes-HZj8RK.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/33a1f2df-1dbb-49ae-9791-41cb4e811981/air-force-1-07-lv8-shoes-HZj8RK.png",
        ten:"",

},
    offer: "Just In",
    shoeName: "Nike Air Force 1'07 LV8",
    type: "Men's Shoes",
    colors: 1,
    price: "₹ 9 695"
}, {
    id: 15,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/a4474910-c618-4c82-91b4-68c387ec848a/air-force-1-low-retro-shoes-j9C2WJ.png",
        imgTwo: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/1edb606b-0474-4096-959d-817fc0f399d4/air-force-1-low-retro-shoes-j9C2WJ.png"
    }, 
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/4173e966-5dd2-4ea2-adb2-115129a9d1c0/air-force-1-07-lv8-shoes-HZj8RK.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/66695227-bd2e-4d98-b812-7f3304e1c457/air-force-1-07-lv8-shoes-HZj8RK.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/b85cb5b8-1300-4d59-8860-2266118114dc/air-force-1-07-lv8-shoes-HZj8RK.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/886e1c89-1118-43a6-b961-5c34285c9a45/air-force-1-07-lv8-shoes-HZj8RK.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/060cf081-168f-4e7a-add2-7580c7255ea9/air-force-1-07-lv8-shoes-HZj8RK.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/ac790962-df2a-45c6-84c4-b2a320933b8f/air-force-1-07-lv8-shoes-HZj8RK.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/fac366b1-68ab-4a10-b21a-3ebf6b81262e/air-force-1-07-lv8-shoes-HZj8RK.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/33a1f2df-1dbb-49ae-9791-41cb4e811981/air-force-1-07-lv8-shoes-HZj8RK.png",
        ten:"",

},
    offer: "Promo Exclution",
    shoeName: "Nike Air Force 1 Low Retro",
    type: "Men's Shoes",
    colors: 2,
    price: "₹ 12 795"
}, {
    id: 16,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/376b6d90-a40e-4197-b709-470befbe3834/air-max-97-shoes-3BHgt0.png",
    }, 
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/fdf3f1dc-67a4-480d-be59-087504dcc9fd/air-max-97-shoes-3BHgt0.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/4336f891-d24d-4c9e-88b1-b3b5d88158d0/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/7167542c-4cea-48c9-9d55-26c275c8c9df/air-max-97-shoes-3BHgt0.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/9844bd10-c5f3-4839-b34b-c38f653cb4c3/air-max-97-shoes-3BHgt0.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/101ec00c-91a3-4144-8d17-fea1c51d4568/air-max-97-shoes-3BHgt0.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/a27377b7-3ef6-4cc7-ae58-b02b97e63084/air-max-97-shoes-3BHgt0.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/19ba2dde-5533-47c9-b047-8762a6ae5a4b/air-max-97-shoes-3BHgt0.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/e6c1c825-4773-4877-ac54-054ad731f75a/air-max-97-shoes-3BHgt0.png",
        nine:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/ce081a78-80c9-4385-adf9-032ffb31ab1c/air-max-97-shoes-3BHgt0.png",
        ten:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/59e422bf-201c-4cad-94c2-f5aab2eb2ea5/air-max-97-shoes-3BHgt0.png",

},
    offer: "Just In",
    shoeName: "Nike Air Max 97",
    type: "Men's Shoes",
    colors: 1,
    price: "₹ 15 995"
}, {
    id: 17,
    images: {
        imgOne: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/75c9b318-fc54-4cda-a9af-1fbb63b56c70/kd15-ep-basketball-shoes-9K6BpD.png",
    }, 
    gallery: {
        One:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/e6962ac2-c2fd-4361-a727-3cb694dcf1bc/kd15-ep-basketball-shoes-9K6BpD.png",
        two:"https://static.nike.com/a/videos/q_90,vc_vp9/14b1ea19-190f-40ed-a36a-1ed1d74ae8ed/video.webm",
        three:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/eff731b4-90ae-41e7-8a92-3bf0af8b67ed/kd15-ep-basketball-shoes-9K6BpD.png",
        four:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/3c0bb825-d535-44b7-b968-ad70ff8bf210/kd15-ep-basketball-shoes-9K6BpD.png",
        five:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/5412f0a9-c92b-4baf-b697-8362a61fd78e/kd15-ep-basketball-shoes-9K6BpD.png",
        six:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/4c6f2690-d7f1-44d0-93d4-023fd96eb395/kd15-ep-basketball-shoes-9K6BpD.png",
        seven:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/adc19c3d-b4b0-4e4d-9857-9074d5ef90fa/kd15-ep-basketball-shoes-9K6BpD.png",
        eight:"https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/a201e444-8dc8-46e6-80f8-b7a6b539c4a1/kd15-ep-basketball-shoes-9K6BpD.png",
        nine:"",
        ten:"",

},
    offer: "Just In",
    shoeName: "KD15 EP",
    type: "BasketBall Shoes",
    colors: 1,
    price: "₹ 13 995"
}]

export default allShoeApi